import React from 'react';

const Header = () => {
  return (
    <header className="header">
      <div className="header-center">
        <img src="/images/AMAZING_Black_Logo-cf8f90846cf0d510afcc4be40c40744027efbca2d317c479243da964b7e2b486.svg" alt="Amaze" className="logo-large" />
      </div>
    </header>
  );
};

export default Header; 